<div class="consent_container">
    <p-dialog [(visible)]="displayDialog" [modal]="true" [closable]="false" [draggable]="false"
        [breakpoints]="{'960px': '75%', '640px': '100%'}" [style]="{width: '50vw'}" position="bottom-left">

        <h2 class=" flex align-items-center gap-3">
            <img class="cookie" src="assets/images/cookie.svg" alt="Cookie Icon" />
            <span>
                {{ 'cookies-consent.page-title' | translate }}
            </span>
        </h2>
        <div class="consent-message text-xl md:text-base">
            {{ 'cookies-consent.page-message1' | translate }}
            <a target="_blank" class="cursor-pointer text-primary" (click)="downloadDocument()">
                {{ 'cookies-consent.cookies-link' | translate }}.
            </a>
            {{ 'cookies-consent.page-message2' | translate }}
        </div>
        <ng-template pTemplate="footer">
            <div class="flex flex-column md:flex-row md:justify-content-end gap-2">
                <p-button label="{{ 'cookies-consent.page-deny' | translate }}" icon="pi pi-times"
                    styleClass="p-button-outlined font-medium w-full md:w-auto" (onClick)="denyCookies()">
                </p-button>
                <p-button label="{{ 'cookies-consent.page-accept' | translate }}" icon="pi pi-check"
                    styleClass="p-button-primary font-medium w-full md:w-auto" (onClick)="acceptCookies()">
                </p-button>
            </div>
        </ng-template>
    </p-dialog>
</div>